import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import common_en from "@idwal/idwal-react-components/translations/en/common.json";
import app_locale_en from "./translations/en/locale.json";

// Single source of truth for i18next initialisation. Imported once from index.tsx.
// Consolidating here (instead of a second init() in services/Translation.ts) avoids the
// import-order race where Translation.ts could init the singleton first — without resources
// or lng — and leave the UI rendering raw keys on cold load.
//
// react-i18next 14 REQUIRES the initReactI18next plugin to be registered on the instance —
// v11 tolerated its absence, but without it v14's useTranslation returns raw keys for every
// component. `defaultNS: "locale"` preserves the app's original default namespace (the bare
// i18next.t / no-arg useTranslation() sites resolve app keys, which all live in locale.json).
i18next.use(initReactI18next).init({
    interpolation: { escapeValue: false },
    lng: "en",
    ns: ["locale", "common"],
    defaultNS: "locale",
    returnNull: false,
    resources: {
        en: {
            common: common_en,
            locale: app_locale_en
        }
    }
});

export default i18next;
